// Imports
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-paragraph-type=\"blockquote\"]{\n    background-color: #efefef;\n    font-size: 1.5em;\n}", "",{"version":3,"sources":["webpack://src/TypedParagraph.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,gBAAgB;AACpB","sourcesContent":["[data-paragraph-type=\"blockquote\"]{\n    background-color: #efefef;\n    font-size: 1.5em;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
